/**
 * Is this offering resting?
 *
 * A sleeping session stays on the booking page on purpose — a client should still see that it
 * exists and be able to ask about it — but it cannot be chosen (owner, Jun 2026). An
 * `asleep_until` date in the past means it has already woken on its own.
 */
export const isAsleep = (sessionType) => {
  if (!sessionType?.asleep) return false;
  const until = (sessionType.asleep_until || '').trim();
  if (!until) return true;
  const wake = new Date(`${until.slice(0, 10)}T23:59:59`);
  if (Number.isNaN(wake.getTime())) return true;
  return wake.getTime() > Date.now();
};

export const sleepNote = (sessionType) => {
  if (!isAsleep(sessionType)) return '';
  const until = (sessionType.asleep_until || '').trim();
  if (!until) return 'Not currently booking';
  const wake = new Date(`${until.slice(0, 10)}T12:00:00`);
  return Number.isNaN(wake.getTime())
    ? 'Not currently booking'
    : `Not currently booking · back ${wake.toLocaleDateString(undefined,
        { month: 'short', day: 'numeric' })}`;
};

export default isAsleep;
